import Error from './component/Error';

function ForbiddenView() {
  return (
    <Error
      status={403}
      title="No Permission"
      description="The page you’re trying to access has restricted access."
    />
  );
}

export default ForbiddenView;
